import {
  GradProgram as ApiGradProgram,
  fetchGradProgram as apiFetchGradProgram,
} from 'api/gradSchools';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch, GetState } from '../..';
// eslint-disable-next-line no-restricted-imports
import { setError } from '../error';

// Types

export type GradProgram = ApiGradProgram & {
  isFetching: boolean;
};
export type State = {
  byId: Record<string, GradProgram>;
};

type FetchGradProgramRequestAction = {
  type: 'GRAD_SCHOOLS_FETCH_PROGRAM_REQUEST';
  programId: string;
};
type FetchGradProgramSuccessAction = {
  type: 'GRAD_SCHOOLS_FETCH_PROGRAM_SUCCESS';
  program: ApiGradProgram;
};
export type Action =
  | FetchGradProgramRequestAction
  | FetchGradProgramSuccessAction;

// Reducer

export function gradProgramsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'GRAD_SCHOOLS_FETCH_PROGRAM_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.programId]: {
            ...state.byId[action.programId],
            id: action.programId,
            isFetching: true,
          },
        },
      };

    case 'GRAD_SCHOOLS_FETCH_PROGRAM_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.program.id]: { ...action.program, isFetching: false },
        },
      };

    default:
      return state;
  }
}

// Actions

const fetchGradProgramRequest = (
  programId: string
): FetchGradProgramRequestAction => ({
  type: 'GRAD_SCHOOLS_FETCH_PROGRAM_REQUEST',
  programId,
});

const fetchGradProgramSuccess = (
  program: ApiGradProgram
): FetchGradProgramSuccessAction => ({
  type: 'GRAD_SCHOOLS_FETCH_PROGRAM_SUCCESS',
  program,
});

export const fetchGradProgram =
  (programId: string) =>
  (dispatch: Dispatch, getState: GetState): Promise<ApiGradProgram | Error> =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line consistent-return
    new Promise((resolve, reject) => {
      const {
        gradSchools: { gradPrograms },
      } = getState();
      // @ts-expect-error fix me
      const program = gradPrograms.byId[programId];

      if (!program) {
        dispatch(fetchGradProgramRequest(programId));
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line no-promise-executor-return
        return apiFetchGradProgram(programId)
          .then((fetchedGradProgram) => {
            dispatch(fetchGradProgramSuccess(fetchedGradProgram));
            resolve(fetchedGradProgram);
          })
          .catch((e) => {
            if (e.statusCode !== 404) {
              dispatch(setError(e));
            } else {
              reject(e);
            }
          });
      }
    });
export const updateGradProgram = fetchGradProgramSuccess;
